export default "__VITE_ASSET__BGoi8Jq$__"